export default "__VITE_ASSET__Bv1bCCVX__"